import { createTheme } from "@material-ui/core/styles";
import { makeStyles } from "@material-ui/core";

export const muiTheme = createTheme({
  props: {
    MuiTextField: {
      autoFocus: true,
      variant: "outlined",
      inputProps: {
        autoComplete: "off",
      },
    },
  },
  overrides: {
    MuiTextField: {
      root: {
        "& > *": {
          display: "flex",
          alignItems: "center",
          justifyContent: "right",
          paddingBottom: "0px",
          maxWidth: "366px",
          maxHeight: "42px",
          marginBottom: "15px",
          "@media (max-height: 700px)": {
            maxHeight: "32px",
            fontSize: "13px",
            marginBottom: "4px",
          },
        },
        "& label.Mui-focused": {
          color: "#243D7F",
        },
        // focused color for input with variant='standard'
        "& .MuiInput-underline:after": {
          borderBottomColor: "#243D7F",
        },
        // focused color for input with variant='filled'
        "& .MuiFilledInput-underline:after": {
          borderBottomColor: "#243D7F",
        },
        // focused color for input with variant='outlined'
        "& .MuiOutlinedInput-root": {
          "&.Mui-focused fieldset": {
            borderColor: "#243D7F",
          },
        },
      },
    },
    MuiInputLabel: {
      root: {
        display: "flex",
        marginTop: "-5px",
        "@media (max-height: 700px)": {
          fontSize: "12px",
          marginTop: "-10px",
        },
      },
    },
    MuiMenuItem: {
      root: {
        "@media (max-height: 700px)": {
          fontSize: "12px",
        },
      },
    },
  },
});

export const useStyles = makeStyles((theme) => ({
  root: (props) => ({
    display: "flex",
    width: "100%",
    "& > *": {
      display: "flex",
      padding: "36px",
      minWidth: "340px",
      maxWidth: "340px",
      "@media (max-height: 700px)": {
        minWidth: "270px",
        maxWidth: "270px",
      },
    },
  }),
}));
